// extracted by mini-css-extract-plugin
module.exports = {"content":"ProjectInsightsFailureRate-module_content__2wDEtoW6Ku47Ht2uotDBi6","csvDownloadWrap":"ProjectInsightsFailureRate-module_csvDownloadWrap__2FLD64lRd1pAycN-pbJ554"};